module.exports = __webpack_public_path__ + "static/media/sopt5ru.d0d05636.pdf";